import { WizerIntegrationResponseData } from '@atbay/productivity-integrations-node-sdk'
import { BaseModule } from '@core/base/module/base-module'
import { ProductivityIntegrationsService } from '@core/services/api-gateway'
import { Analytics } from '@core/services/mixpanel'
import Cookies from 'js-cookie'

const state = {
    integration: {
        isActive: false,
        wizerCompanyId: '',
        createdAt: '',
        user: {
            email: '',
            userType: 'USER',
            createdAt: '',
        },
    },
    magicLink: {
        link: '',
        error: '',
    },
    loading: false,
    clicked: false,
} satisfies TProductivityIntegrationState

class ProductivityIntegrations extends BaseModule<TProductivityIntegrationState> {
    constructor(state: TProductivityIntegrationState) {
        super(state, 'productivity-integrations.module')
    }

    isWizerIntegrationActive(): boolean {
        const { integration } = this.store.get()
        return !!(
            integration &&
            integration.isActive &&
            integration.wizerCompanyId
        )
    }

    async getWizerIntegration() {
        this.store.setKey('loading', true)
        const result: WizerIntegrationResponseData =
            await ProductivityIntegrationsService.getWizerIntegration()
        this.store.setKey('loading', false)
        if (result) {
            this.store.setKey('integration', {
                isActive: result.is_active,
                wizerCompanyId: result.wizer_company_id,
                createdAt: result.created_at,
                user: !result.user
                    ? undefined
                    : {
                          email: result.user.email,
                          userType: result.user.user_type,
                          createdAt: result.user.created_at,
                      },
            })
        } else {
            console.info(
                'Wizer is not active for this account, or there was an error fetching the integration status'
            )
        }
    }

    async getWizerMagicLink() {
        this.store.setKey('loading', true)

        const magicLinkFromCookie = Cookies.get('wizerMagicLink')
        if (magicLinkFromCookie) {
            window.open(magicLinkFromCookie, '_blank')
            this.store.setKey('loading', false)
            return {
                link: magicLinkFromCookie,
                error: '',
            }
        }

        const magicLinkRes =
            await ProductivityIntegrationsService.generateWizerMagicLink()
        this.store.setKey('loading', false)
        await ProductivityIntegrationsModule.setClicked(false)
        if (magicLinkRes?.link) {
            Cookies.set('wizerMagicLink', magicLinkRes.link, {
                // Expires in 27 minutes
                expires: new Date(Date.now() + 27 * 60 * 1000),
            })
            if (!this.isWizerIntegrationActive()) {
                // first time generating magic link
                Analytics.event('SEM::integration_connected', {
                    integrationType: 'wizer',
                    displayName: 'Wizer',
                    authType: 'magic_link',
                    action: 'add',
                    origin: 'wizer-widget',
                })
                await this.getWizerIntegration()
            }
        } else {
            Analytics.event('SEM::integration_failed', {
                integrationType: 'wizer',
                displayName: 'Wizer',
                authType: 'magic_link',
                action: 'add',
                origin: 'wizer-widget',
                reason: magicLinkRes.error,
            })
            console.error(
                'Unexpected response for Wizer integration status, link ' +
                    magicLinkRes.error
            )
        }
        return magicLinkRes
    }

    async setClicked(value: boolean) {
        this.store.setKey('clicked', value)
    }
}

export const ProductivityIntegrationsModule = new ProductivityIntegrations(
    state
)
